import { whatsHotData } from '../../apis';
import { _getDontMiss } from '../../controllers';
import { getMktSegIdFromMappedMktSegId } from '../../utils/global_functions';
import { WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { SEARCH_DONTMISS_BY_DROPDOWN, SEARCH_DONTMISS_BY_SYMBOL, WATCHLIST } from '../actionTypes';

function getDontMiss(watchlists, whatsHotData) {

    const hotList = new Map();
    const dontMiss = [];

    // Create a object of hotList data and Map with keys
    whatsHotData?.forEach(({ mktid, token, class: class1, class2, event, date, Desc }) => {
        if (hotList.has(`${mktid}_${token}`)) {
            const arrHotList = hotList.get(`${mktid}_${token}`);
            arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
            hotList.set(`${(getMktSegIdFromMappedMktSegId(mktid))}_${token}`, arrHotList);
        } else {
            hotList.set(`${(getMktSegIdFromMappedMktSegId(mktid))}_${token}`, [{ color: class1, bg_color: class2, event, date, Desc }]);
        }
    });

    // Loop through watchlists and scrips to build dontMiss array
    for (let i = 0; i < watchlists?.length; i++) {
        let { sWatchListName, scrips } = watchlists[i];
        for (let index = 0; index < scrips.length; index++) {
            let scrip = scrips[index];

            if (hotList.has(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])) {
                let arrDontMissScrip = scrip;
                arrDontMissScrip = [
                    ...scrip,
                ];
                arrDontMissScrip[WATCHLIST_GRID_INDEX.DONT_MISS] = hotList.get(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                arrDontMissScrip[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [sWatchListName];
                if (!dontMiss.some(each => each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])) { // Avoid Duplicate Scrips
                    dontMiss.push(JSON.parse(JSON.stringify(arrDontMissScrip)));
                } else {
                    const nIndexOfDontMiss = dontMiss?.findIndex((item) => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                    dontMiss[nIndexOfDontMiss][WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS]?.push(sWatchListName);
                }
                scrips[index] = JSON.parse(JSON.stringify(arrDontMissScrip));
            }
        }
    }
    const arrUpdateWatchlistsAfterDontMiss = JSON.parse(JSON.stringify(watchlists));
    return [dontMiss, arrUpdateWatchlistsAfterDontMiss];
}


export const getWhatsHotData = (arrUpdatedWatchlist) => async (dispatch, getState) => {
    try {

        const objTopTenRecommendationsData = getState()?.recommendation?.objTopTenRecommendationsData;
        const objResp = await whatsHotData();
        dispatch(getWhatsHotDataSuccess(objResp?.data?.result));
        const objDontMissResponse = await _getDontMiss(arrUpdatedWatchlist, objResp?.data?.result, objTopTenRecommendationsData);

        if (objDontMissResponse?.status) {
            const { allDontMissScrips, arrUpdateWatchlistsAfterDontMiss, resultObject } = objDontMissResponse?.data;
            dispatch(updateGroupedDontMissData(resultObject))
            dispatch(updateDontMissData(allDontMissScrips));
            return new Promise(resolve => {
                resolve([allDontMissScrips, arrUpdateWatchlistsAfterDontMiss]);
            });
        }


    } catch (error) {
        console.log(error);
        dispatch(updateDontMissData([]));
        dispatch(updateGroupedDontMissData([]))
        dispatch(getWhatsHotDataFailure([]));
        return new Promise((resolve, reject) => {
            reject([[], arrUpdatedWatchlist]);
        });
    }
};

export const searchDontMissBySymbol = (payload) => {
    return { type: SEARCH_DONTMISS_BY_SYMBOL, payload: payload };
};

export const setDontMissSearchByDropdown = (payload) => {
    return { type: SEARCH_DONTMISS_BY_DROPDOWN, payload: payload };
};

export const getWhatsHotDataSuccess = (payload) => {
    return { type: WATCHLIST.GET_WHATS_HOT_DATA_SUCCESS, payload: payload };
};

export const getWhatsHotDataFailure = (payload) => {
    return { type: WATCHLIST.GET_WHATS_HOT_DATA_FAILURE, payload: payload };
};
export const getDontMissInfo = () => {
    return { type: WATCHLIST.GET_DONT_MISS_INFO, payload: {} };
};

export const updateDontMissData = (payload) => {
    return { type: WATCHLIST.GET_DONT_MISS_DATA, payload: payload };
};


export const updateGroupedDontMissData = (payload) => {
    return { type: WATCHLIST.UPDATE_GROUPED_DONT_MISS, payload: payload };
};